import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import LocalStorageService from "@/services/LocalStorageService";
import ConfigService from "./services/ConfigService";

const localStorageService = LocalStorageService.getService();

Vue.use(Router)
let router = new Router({
  base: process.env.BASE_URL,
  routes:
      [
        {
          path: '/',
          name: 'home',
          meta: {
            requiresAuth: false
          },
          component: Home
        },
        {
          path: '/timeout',
          name: 'timeout',
          meta: {
            requiresAuth: false
          },
          component: () => import(/* webpackChunkName: "timeout" */ './views/Timeout.vue')
        },
        {
          path: '/unauthorized',
          name: 'unauthorized',
          meta: {
            requiresAuth: false
          },
          component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue')
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "unauthorized" */ './views/Dashboard.vue')
        },
        {
          path: '/new',
          name: 'new',
          meta: {
            requiresAuth: true,
            authRoles: ['APPLICANT']
          },
          component: () => import(/* webpackChunkName: "unauthorized" */ './views/NewApplication.vue'),
        },
        {
            path: '/submitter/:id',
            name: 'submitter',
            meta: {
                requiresAuth: true,
                authRoles: ['APPLICANT']
            },
            component: () => import(/* webpackChunkName: "unauthorized" */ './views/Submitter.vue')
        },
        {
          path: '/contacts/:id',
          name: 'contacts',
          meta: {
            requiresAuth: true,
            authRoles: ['APPLICANT']
          },
          component: () => import(/* webpackChunkName: "unauthorized" */ './views/Contacts.vue')
        },
        {
          path: '/attachments/:id',
          name: 'attachments',
          meta: {
            requiresAuth: true,
            authRoles: ['APPLICANT']
          },
          component: () => import(/* webpackChunkName: "unauthorized" */ './views/Attachments.vue')
        },
        {
          path: '/document',
          name: 'document',
          meta: {
            requiresAuth: true,
            authRoles: ['APPLICANT']
          },
          props: true,
          component: () => import(/* webpackChunkName: "unauthorized" */ './views/Document.vue')
        },
        {
          path: '/view/:id',
          name: 'view',
          meta: {
            requiresAuth: true
          },
          component: () => import(/* webpackChunkName: "unauthorized" */ './views/ViewApplication.vue')
        },
        {
            path: '/pc-transfer',
            name: 'pc-transfer',
            meta: {
                requiresAuth: true,
                authRoles: ['MANAGE_UPLOAD_REQUESTS']
            },
            component: () => import(/* webpackChunkName: "unauthorized" */ './views/reports/PCTransfer.vue'),
        },
        {
          path: '*',
          component: Home
        }
      ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak && router.app.$keycloak.authenticated) {
      if (to.meta.authRoles) {
        let hasRole = false
        for (var i = 0; i < to.meta.authRoles.length; i++) {
          if (router.app.$keycloak.hasResourceRole(to.meta.authRoles[i], ConfigService.getBackendClientName())) {
            hasRole = true;
          }
        }
        if (hasRole) {
          next()
        } else {
          router.push('unauthorized')
        }
      } else {
        next();
      }
    } else {
      const url = localStorageService.getLoginUrl()
      window.location.replace(url)
    }
  } else {
    next()
  }
})

export default router